<section #container>
  @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
  <div
    class="container"
    [formGroup]="formGroup">
    <div class="title m-t-16">{{ 'BLOCKED_NUM_PREFERENCES.BLOCKED_NUMBERS' | translate }}</div>
    <mat-divider class="m-t-6"></mat-divider>
    <div class="title m-t-16">{{ 'BLOCKED_NUM_PREFERENCES.ADD_A_NUMBER' | translate }}</div>
    <div class="flex-col">
      <div class="row items-holder m-t-16 m-b-16 number-input">
        <mat-form-field
          appearance="outline"
          hideRequiredMarker
          class="density-minus-3">
          <mat-label>{{ 'BLOCKED_NUM_PREFERENCES.ENTER_A_NUMBER' | translate }}</mat-label>
          <input
            autocomplete="off"
            formControlName="blockedNumber"
            matInput />
        </mat-form-field>
        <button
          mat-icon-button
          color="primary"
          (click)="addBlockedNumbers()"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color">
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
      @for (number of blockedNumbers; track $index) {
        <div class="number-item">
          <span class="number">
            {{ number | phoneNumber }}
          </span>
          <span
            (click)="removeBlockedNumber(number)"
            class="remove">
            <mat-icon
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color">
              delete_outline</mat-icon
            >
          </span>
        </div>
      }
      <mat-checkbox
        class="m-t-16 m-b-16"
        formControlName="blockAnonymous"
        (ngModelChange)="onCheckChangeBlockAnonymous()"
        color="primary"
        [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
        <!-- Block anonymous or unknown numbers -->
        {{ 'BLOCKED_NUM_PREFERENCES.BLOCK_ANON' | translate }}
      </mat-checkbox>
    </div>
    <div class="title m-t-16">{{ 'BLOCKED_NUM_PREFERENCES.ALLOWED_NUMBERS' | translate }}</div>
    <mat-divider class="m-t-16"></mat-divider>
    <div class="flex-col">
      <div class="row items-holder m-t-16 m-b-16 number-input">
        <mat-form-field
          appearance="outline"
          hideRequiredMarker
          class="density-minus-3">
          <mat-label>{{ 'BLOCKED_NUM_PREFERENCES.ENTER_A_NUMBER' | translate }}</mat-label>
          <input
            autocomplete="off"
            formControlName="allowedNumber"
            matInput />
        </mat-form-field>
        <button
          mat-icon-button
          color="primary"
          (click)="addAllowedNumbers()"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color">
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
      @for (number of allowedNumbers; track $index) {
        <div class="number-item">
          <span class="number">
            {{ number | phoneNumber }}
          </span>
          <span
            (click)="removeAllowedNumber(number)"
            class="remove">
            <mat-icon
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color">
              delete_outline</mat-icon
            >
          </span>
        </div>
      }
    </div>
  </div>
  @if (editingDisabled) {
    <div
      class="grey-mask"
      #greyMask></div>
  }
</section>
